import { isCODWithoutPartialPayment } from "../../utils/order.util";

const serviceChargeMapping = {
  cc: (deliveryOption) => (deliveryOption && deliveryOption.key === "international" ? 4.99 : 2.85),
  dc: (price, deliveryOption) =>
    deliveryOption && deliveryOption.key === "international" ? 4.99 : price > 2000 ? 2 : 1.45,
  upi: 1.2,
  app: 2.8,
  nb: 2.75,
};

const getPrice = (deliveryOption, cart, paymentMode = null, processingFeePayee) => {
  const partialPaymentPercentage = deliveryOption.partialPaymentPercentage;
  let calculatedPrice = 0;
  let shippingFeeApplied = false;
  let shippingFee = deliveryOption.shippingCharge;
  let discountedAmount = cart?.discountedAmount;
  let couponId, couponCode;
  if (discountedAmount) {
    couponId = cart.couponId;
    couponCode = cart.couponCode;
  }
  const actualShippingFee = cart.shippingFee;
  const shippingFeeCap = Number.isInteger(cart.shippingFeeCap)
    ? cart.shippingFeeCap
    : Number.MAX_SAFE_INTEGER;
  for (const product of cart.products) {
    const productQuantity = product.quantity ? product.quantity : 1;
    calculatedPrice += product.price * productQuantity;
  }

  let priceWithoutFees = calculatedPrice;
  if (discountedAmount) {
    calculatedPrice = priceWithoutFees - discountedAmount;
  }

  if (calculatedPrice < shippingFeeCap) {
    calculatedPrice += shippingFee ? shippingFee : 0;
    shippingFeeApplied = true;
  } else {
    shippingFee = 0;
  }

  const productTotalPrice = calculatedPrice;
  let processingFee = 0;
  if (isCODWithoutPartialPayment(deliveryOption)) {
    processingFee = 0;
  } else if (paymentMode === "dc") {
    processingFee = Number(
      (
        calculatedPrice *
        (serviceChargeMapping[paymentMode](calculatedPrice, deliveryOption) / 100)
      ).toFixed(2),
    );
  } else if (paymentMode === "cc") {
    processingFee = Number(
      (calculatedPrice * (serviceChargeMapping[paymentMode](deliveryOption) / 100)).toFixed(2),
    );
  } else if (paymentMode) {
    processingFee = Number(
      (calculatedPrice * (serviceChargeMapping[paymentMode] / 100)).toFixed(2),
    );
  } else {
    processingFee = Number((calculatedPrice * 0.02).toFixed(2));
  }

  const pricewithShipping = calculatedPrice;

  if (!processingFeePayee) {
    calculatedPrice += processingFee;
  } else if (processingFeePayee !== "self") {
    calculatedPrice += processingFee;
  }

  let partialPaymentPrice = null;
  if (partialPaymentPercentage) {
    partialPaymentPrice = pricewithShipping * (partialPaymentPercentage / 100) + processingFee;
  }

  calculatedPrice = calculatedPrice != 0 ? calculatedPrice.toFixed(2) : calculatedPrice;

  return {
    productTotalPrice: productTotalPrice,
    total: calculatedPrice,
    shippingFee,
    shippingFeeCap,
    actualShippingFee,
    paymentProcessingFee: processingFee,
    shippingFeeApplied,
    priceWithoutFees,
    couponId,
    couponCode,
    partialPaymentPrice,
  };
};

export { getPrice };
